"use strict";

exports.__esModule = true;
exports.DsButtonToggle = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
var _react = require("react");
var _reactBootstrap = require("react-bootstrap");
var _DsContextualHelp = require("../contextual-help/DsContextualHelp");
var _jsxRuntime = require("react/jsx-runtime");
var LooksOneOutline = function LooksOneOutline(_ref) {
  var position = _ref.position,
    children = _ref.children,
    disabled = _ref.disabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [position == 'left' && /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      className: "me-1 " + (disabled ? 'text-secondary' : ''),
      xmlns: "http://www.w3.org/2000/svg",
      height: "33.66px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "#000000",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-7-2h2V7h-4v2h2z",
        fill: "currentColor"
      })]
    }), children, position == 'right' && /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      className: "ms-1 " + (disabled ? 'text-secondary' : ''),
      xmlns: "http://www.w3.org/2000/svg",
      height: "33.66px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "#000000",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-7-2h2V7h-4v2h2z",
        fill: "currentColor"
      })]
    })]
  });
};
var ToggleItem = function ToggleItem(_ref2) {
  var id = _ref2.id,
    item = _ref2.item,
    currentValue = _ref2.currentValue,
    onChange = _ref2.onChange,
    size = _ref2.size,
    iconOnly = _ref2.iconOnly;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "btn btn-toggle-" + (item.disable ? 'secondary' : 'primary') + " " + (iconOnly ? 'btn-icon h-100' : '') + " " + (item.value === currentValue ? 'active' : '') + " " + (size === 'sm' ? 'py-0 px-2' : size === 'md' ? 'px-3' : 'px-4'),
    style: item.disable ? {
      cursor: 'not-allowed'
    } : {},
    tabIndex: 0,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: 'radio',
      name: id,
      disabled: item.disable,
      id: id + "-" + item.value,
      value: item.value,
      onClick: function onClick() {
        return onChange(item.value);
      }
    }), item.iconLabel && item.iconLabel === 'looks_one_outline' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LooksOneOutline, {
      position: item.iconPosition,
      children: item.label
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [item.iconLabel && item.iconPosition === 'left' && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-md " + (item.label ? 'me-1' : ''),
        children: item.iconLabel
      }), item.label, item.iconLabel && item.iconPosition === 'right' && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-md " + (item.label ? 'ms-1' : ''),
        children: item.iconLabel
      })]
    })]
  });
};
var DsButtonToggle = exports.DsButtonToggle = function DsButtonToggle(_ref3) {
  var id = _ref3.id,
    label = _ref3.label,
    items = _ref3.items,
    defaultValue = _ref3.defaultValue,
    onChange = _ref3.onChange,
    contextualHelpId = _ref3.contextualHelpId,
    openContextualHelp = _ref3.openContextualHelp,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'md' : _ref3$size,
    _ref3$iconOnly = _ref3.iconOnly,
    iconOnly = _ref3$iconOnly === void 0 ? false : _ref3$iconOnly,
    _ref3$additionalClass = _ref3.additionalClassNames,
    additionalClassNames = _ref3$additionalClass === void 0 ? '' : _ref3$additionalClass;
  var _useState = (0, _react.useState)(defaultValue),
    currentValue = _useState[0],
    setCurrentValue = _useState[1];
  (0, _react.useEffect)(function () {
    setCurrentValue(defaultValue);
  }, [defaultValue]);
  var handleChange = function handleChange(value) {
    if (onChange) {
      setCurrentValue(value);
      onChange(value);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        className: 'mt-2',
        htmlFor: id,
        children: label
      }), contextualHelpId && openContextualHelp && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DsContextualHelp.DsContextualHelp, {
        id: contextualHelpId,
        openContextualHelp: openContextualHelp
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "btn-group btn-group-toggle " + additionalClassNames,
      "data-toggle": "buttons",
      role: "group",
      "aria-label": "toggle buttons single select",
      children: items.map(function (item) {
        return item.tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBootstrap.OverlayTrigger, {
          placement: "bottom",
          overlay: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBootstrap.Tooltip, {
            id: "badge-tooltip-contents",
            className: 'badge-tooltip',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
              className: "text-secondary breadcrumb-item",
              children: item.tooltip
            })
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            className: "btn btn-toggle-" + (item.disable ? 'secondary' : 'primary') + " " + (iconOnly ? 'btn-icon h-100' : '') + " " + (item.value === currentValue ? 'active' : '') + " " + (size === 'sm' ? 'py-0 px-2' : size === 'md' ? 'px-3' : 'px-4'),
            style: item.disable ? {
              cursor: 'not-allowed'
            } : {},
            tabIndex: 0,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              type: 'radio',
              name: id,
              disabled: item.disable,
              id: id + "-" + item.value,
              value: item.value,
              onClick: function onClick() {
                return handleChange(item.value);
              }
            }), item.iconLabel && item.iconLabel === 'looks_one_outline' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LooksOneOutline, {
              position: item.iconPosition,
              children: item.label
            }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [item.iconLabel && item.iconPosition === 'left' && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                className: "icon icon-md " + (item.label ? 'me-1' : ''),
                children: item.iconLabel
              }), item.label, item.iconLabel && item.iconPosition === 'right' && /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                className: "icon icon-md " + (item.label ? 'ms-1' : ''),
                children: item.iconLabel
              })]
            })]
          })
        }, id + "-" + item.value) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ToggleItem, {
          item: item,
          onChange: handleChange,
          id: id,
          currentValue: currentValue,
          size: size,
          iconOnly: iconOnly
        }, id + "-" + item.value);
      })
    })]
  });
};